import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecaptchaFormsModule, RecaptchaModule, RecaptchaV3Module } from 'ng-recaptcha';

import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ClientFormInputContentListModule } from '../client-form-input-content-list/client-form-input-content-list.module';
import { ClientFormPageStepComponent } from './client-form-page-step/client-form-page-step.component';
import { ClientFormPageStepsComponent } from './client-form-page-steps.component';
import { ArchwizardModule } from '@app/external/angular-archwizard';
import { ClientFormInstructionComponent } from './client-form-instruction/client-form-instruction.component';

@NgModule({
  declarations: [ClientFormPageStepsComponent, ClientFormPageStepComponent, ClientFormInstructionComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule, ReactiveFormsModule,
    RecaptchaFormsModule, RecaptchaModule, RecaptchaV3Module,
    ArchwizardModule,
    ClientFormInputContentListModule,
    TooltipModule
  ],
  exports: [ClientFormPageStepsComponent],
  providers: []
})
export class ClientFormPageStepsModule { }
